import { Box, Typography, Button } from "@mui/material";
import { useSnackbar } from "../../../../Components/SnackBar";
import { soonBadge } from "../../styles/styles";
import { useTranslation } from "react-i18next";

export default function InviteContent({
  modalPosition,
  isBelowMd,
  sidebarData,
}) {
  const snackbar = useSnackbar();
  const { t, i18n } = useTranslation("bottom-menu-and-settings");
  const dynamicLinks = sidebarData?.inviteLinks || {};
  const language = i18n.language;
  const inviteLinks = [
    {
      label: t("inviteLinkLabels.general"),
      link: dynamicLinks.general + `-${language}`,
      soon: true,
    },
    {
      label: t("inviteLinkLabels.member"),
      link: dynamicLinks.member + `-${language}`,
      soon: false,
    },
    {
      label: t("inviteLinkLabels.supplier"),
      link: dynamicLinks.supplier + `-${language}`,
      soon: false,
    },
  ];

  const handleCopyLink = (text) => {
    // The link is no longer shown, so a missing clipboard API (non-secure
    // context) must still surface the failure message instead of throwing.
    if (!navigator.clipboard?.writeText) {
      snackbar(t("copy_link_failed"));
      return;
    }
    navigator.clipboard
      .writeText(text)
      .then(() => {
        snackbar(t('user_copy_invite_link'));
      })
      .catch((err) => {
        snackbar(t("copy_link_failed"));
        console.error("Failed to copy: ", err);
      });
  };

  const webStyling = {
    position: "absolute",
    top: `${modalPosition.top - 145}px`,
    left: `280px`,
    bgcolor: "background.paper",
    p: "24px",
    height: "auto",
    borderRadius: "12px",
    minWidth: "300px",
    "&::before": {
      content: '""',
      position: "absolute",
      bottom: "50%",
      left: "-12px",
      transform: "translateY(50%)",
      width: 0,
      height: 0,
      borderTop: "16px solid transparent",
      borderBottom: "16px solid transparent",
      borderRight: "16px solid white",
    },
  };

  const mobileStyling = {
    display: "flex",
    flexDirection: "column",
  };

  return (
    <Box sx={isBelowMd ? mobileStyling : webStyling}>
      <Box sx={{ display: "flex", flexDirection: "column", gap: "24px" }}>
        {inviteLinks.map((item, index) => (
          <Box
            key={index}
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "16px",
            }}
          >
            <Box>
              <Typography
                color="rgba(62, 63, 76, 1)"
                sx={{
                  mb: "8px",
                  fontWeight: 400,
                  fontSize: "15px",
                  textTransform: "capitalize",
                }}
              >
                {item.label}
              </Typography>
              {item.soon ? (
                <Box sx={soonBadge}>{t("soon")}</Box>
              ) : (
                // A copy button instead of the full (long, admin-api) URL.
                <Button
                  onClick={() => handleCopyLink(item.link)}
                  sx={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                    textTransform: "none",
                    fontSize: "13px",
                    fontWeight: 500,
                    color: "rgba(0, 85, 70, 1)",
                    px: "8px",
                    minWidth: 0,
                  }}
                >
                  <img src="/icons/copy-icon.svg" alt="" aria-hidden="true" />
                  {t("copy_link")}
                </Button>
              )}
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
